import { InvoiceEntity, InvoiceListStatus } from "../../domain";

export const INVOICE_STATUS_OPTIONS: Array<{
  label: string;
  value: InvoiceListStatus;
}> = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "On Hold", value: "on_hold" },
  { label: "Under Review", value: "under_review" },
  { label: "Posted", value: "posted" },
  { label: "Duplicate", value: "duplicate" },
  { label: "Rejected", value: "rejected" },
];

export const getInvoiceListStatus = (
  invoice: InvoiceEntity,
): Exclude<InvoiceListStatus, "all"> => {
  if (Number(invoice.is_under_review) === 1) {
    return "under_review";
  }

  if (invoice.status === "3") {
    return "duplicate";
  }

  if (invoice.status === "4") {
    return "rejected";
  }

  if (invoice.status === "1" && invoice.reviewed === "1") {
    return "posted";
  }

  if (Number(invoice.on_hold) === 1) {
    return "on_hold";
  }

  return "pending";
};

export const getInvoiceListStatusLabel = (status: InvoiceListStatus) => {
  switch (status) {
    case "on_hold":
      return "On Hold";
    case "under_review":
      return "Under Review";
    case "posted":
      return "Posted";
    case "duplicate":
      return "Duplicate";
    case "rejected":
      return "Rejected";
    case "pending":
      return "Pending";
    case "all":
    default:
      return "All";
  }
};
